import { ChangeDetectorRef, Component } from '@angular/core';
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatLabel, MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { LABELS } from 'app/core/constants/label-constants';
import { HelperService, noWhitespaceValidation } from 'app/core/services/helper/helper.service';
import { AccountService } from '../settings/account/account.service';
import { CommonService } from '../common-service/common.service';
import { Router } from '@angular/router';
import { CommonConstants } from 'app/core/constants/common-constants';

@Component({
  selector: 'app-partner-profile',
  standalone: true,
  imports: [MatTabGroup, MatTab, MatFormField, MatLabel, MatIcon, FormsModule,
          ReactiveFormsModule,
          MatFormFieldModule,
          MatIconModule,
          MatInputModule,
          TextFieldModule,
          MatSelectModule,
          MatOptionModule,
          MatButtonModule,],
  templateUrl: './partner-profile.component.html',
  styleUrl: './partner-profile.component.scss'
})
export class PartnerProfileComponent {
   accountForm: UntypedFormGroup;
      url: any = 'placeHolderImage.jpg';
      selectedFile:any;
      isLoad = false;
      profileData: any;
      profilePicture: any
      isPartner: any
      partner: any

      constructor(
        private _formBuilder: UntypedFormBuilder,
                public _helper: HelperService,
                private cdr: ChangeDetectorRef,
                private _apiService: AccountService,
                private _uploadService: CommonService,
                private _router: Router
      ){}

      /**
           * On init
           */
          ngOnInit(): void {
              // Create the form
              this.accountForm = this._formBuilder.group({
                  email: ['', [Validators.required, Validators.pattern(CommonConstants.EMAIL_REGEX)]],
                  firstName: ['', [Validators.required, noWhitespaceValidation.noWhitespaceValidator]],
                  lastName: ['', [Validators.required, noWhitespaceValidation.noWhitespaceValidator]]
              });
          }

      /**
           * Summary: It is use for handle error of image
           * @param e
           */
          setErrorImage(e: any){
              e.target.src = 'placeHolderImage.jpg';
          }
      
          /**
           * Summary: This method is use for select file
           * @param event
           * @param fileInputElement
           */
          fileBrowseHandler(event: any, fileInputElement: any) {
              if (!event.target?.files[0]) {
                  this._helper.toast('No file selected', 'error');
                  fileInputElement.value = '';
                  return;
              }
      
              const maxImageSize = 5 * 1024 * 1024; // 5MB size limit
              const validFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      
              this.selectedFile = event.target?.files[0];
              const { type: imageType, size: imageSize } = this.selectedFile;
      
              if (!validFormats.includes(imageType)) {
                  this._helper.toast(`Invalid image format: ${this.selectedFile.name}`, 'error');
                  fileInputElement.value = '';
                  return;
              }
      
              if (imageSize > maxImageSize) {
                  this._helper.toast(`Image size exceeds 5MB: ${this.selectedFile.name}`, 'error');
                  fileInputElement.value = '';
                  return;
              }
      
              if (validFormats.includes(imageType)) {
                  const reader = new FileReader();
                  reader.readAsDataURL(this.selectedFile);
                  reader.onload = () => {
                      this.url = reader.result;
                      this.cdr.detectChanges();
                  };
              } else {
                  this.selectedFile = '';
                  this.url = 'grimmor-logo.png';
                  this.cdr.detectChanges();
              }
      
              const addFormData = new FormData();
              addFormData.append('file', this.selectedFile)
              addFormData.append('fileType', 'profilePicture');
      
              if(this.selectedFile){
                  this.isLoad = true;
                  this._uploadService.upload(addFormData).subscribe((res: any) => {
                      if(res?.meta?.status == 1){
                          this.profilePicture = res?.data?.files?.length && res.data.files[0].mediaId ? res.data.files[0].mediaId : '';
                          this.isLoad = false;
                          this.cdr.detectChanges();
                      } else {
                          this.isLoad = false;
                          this.cdr.detectChanges();
                          this._helper.toast('Failed to upload images', 'error');
                      }
                  },error => {
                      this.isLoad = false;
                      this.cdr.detectChanges();
                      this._helper.toast('An error occurred during the upload', 'error');
                  })
              }
          }
      
          /**
           * Summary: This method is use for update profile
           * @param form
           */
          updateAccount(form: any){
              this.accountForm.value.firstName = this.accountForm.value.firstName.trim();
              this.accountForm.value.lastName = this.accountForm.value.lastName.trim();
              this.accountForm.markAllAsTouched();
              if(this.accountForm.valid){
                  let getInputsValues = this.accountForm.value;
                  getInputsValues['profilePicture'] = this.profilePicture;
                  this._apiService.updateAccount(getInputsValues, false).subscribe((res: any) => {
                      if(res?.meta?.status == 1){
                          let user = {
                              id: res.data.adminId,
                              firstName: res.data.firstName,
                              lastName: res.data.lastName,
                              email: res.data.email,
                              avatar: res.data.profilePicture
                          }
                          this._helper.setLocalStorageData(CommonConstants.USER_DATA, user)
                          this._helper.userData.next(user);
                          this._helper.toast(res?.meta?.message, 'success');
                      } else {
                          this._helper.toast(res?.meta?.message, 'error');
                      }
                  })
              }
          }

       protected readonly LABELS = LABELS;
      
}
